module.exports = __webpack_public_path__ + "static/img/banner10.94db7847.png";